import React from 'react';
import { NotFound } from './NotFound';
export function UnauthorizedAccess() {
    return (React.createElement(NotFound, { testId: "unauthorized-access-title", heading: "You do not have permission to access this page", subheading: "This page is restricted to specific collaborators and team members. Please contact the project owner or account admin to get access." }));
}
